// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap'); */

body {
  margin: 0;
  font-family: 'Sarabun', sans-serif;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* มือถือ/แท็บเล็ต: iPhone ซูมหน้าจอเข้าเองเมื่อแตะช่องกรอกที่ตัวอักษรเล็กกว่า 16px (และไม่ซูมออกให้)
   → บนจอสัมผัสให้ช่องกรอกทุกช่องเป็น 16px ขึ้นไป (ไม่กระทบคอมพิวเตอร์ที่ใช้เมาส์) */
@media (hover: none) and (pointer: coarse) {
  input,
  textarea,
  select,
  .MuiInputBase-input,
  .MuiSelect-select,
  .MuiAutocomplete-input {
    font-size: 16px !important;
  }
}

.ag-theme-custom,
.ag-theme-custom .ag-cell,
.ag-theme-custom .ag-header-cell,
.ag-theme-custom .ag-header-cell-label,
.ag-theme-custom .ag-row {
  font-family: 'Sarabun', sans-serif !important;
}

.code-style {
  font-family: 'Space Mono', monospace;
  font-size: 14px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gUAAgU;;AAGhU;EACE,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;oFACoF;AACpF;EACE;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;;;;;EAKE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE;aACW;AACb","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap'); */\r\n@import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: 'Sarabun', sans-serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* มือถือ/แท็บเล็ต: iPhone ซูมหน้าจอเข้าเองเมื่อแตะช่องกรอกที่ตัวอักษรเล็กกว่า 16px (และไม่ซูมออกให้)\r\n   → บนจอสัมผัสให้ช่องกรอกทุกช่องเป็น 16px ขึ้นไป (ไม่กระทบคอมพิวเตอร์ที่ใช้เมาส์) */\r\n@media (hover: none) and (pointer: coarse) {\r\n  input,\r\n  textarea,\r\n  select,\r\n  .MuiInputBase-input,\r\n  .MuiSelect-select,\r\n  .MuiAutocomplete-input {\r\n    font-size: 16px !important;\r\n  }\r\n}\r\n\r\n.ag-theme-custom,\r\n.ag-theme-custom .ag-cell,\r\n.ag-theme-custom .ag-header-cell,\r\n.ag-theme-custom .ag-header-cell-label,\r\n.ag-theme-custom .ag-row {\r\n  font-family: 'Sarabun', sans-serif !important;\r\n}\r\n\r\n.code-style {\r\n  font-family: 'Space Mono', monospace;\r\n  font-size: 14px;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
